import uniq from 'lodash.uniq';

export const getQueriedColumnData = (
    columnData: Array<string>,
    query: string,
) => {
    return [
        ...uniq(columnData
            .filter(item => item.toLowerCase().includes(query.toLowerCase()) && item.length)),
    ];
};
